var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwdViewTrue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 4.03897C6.17879 4.03897 2.71351 6.12959 0.15649 9.52532C-0.0521632 9.80352 -0.0521632 10.1922 0.15649 10.4704C2.71351 13.8702 6.17879 15.9608 10 15.9608C13.8212 15.9608 17.2865 13.8702 19.8435 10.4745C20.0522 10.1963 20.0522 9.80761 19.8435 9.52941C17.2865 6.12959 13.8212 4.03897 10 4.03897ZM10.2741 14.1975C7.73755 14.3571 5.64284 12.2664 5.80239 9.72579C5.93331 7.63108 7.63118 5.93321 9.72589 5.80229C12.2625 5.64273 14.3572 7.73336 14.1976 10.274C14.0626 12.3646 12.3647 14.0625 10.2741 14.1975ZM10.1473 12.2583C8.78081 12.3442 7.65163 11.2191 7.74164 9.85262C7.81119 8.72344 8.72763 7.81109 9.85681 7.73745C11.2233 7.65153 12.3525 8.77662 12.2625 10.1431C12.1888 11.2764 11.2724 12.1887 10.1473 12.2583Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwdViewTrue);
export default __webpack_public_path__ + "static/media/pwd-view-true.d077214c8cf6609921a1ce8c8d8e2a90.svg";
export { ForwardRef as ReactComponent };